import { PageLayout, PageTitle } from "../components/PageLayout";
import { useLanguage } from "../contexts/LanguageContext";

export default function Kontakt() {
  const { t } = useLanguage();
  return (
    <PageLayout>
      <PageTitle testId="page-kontakt-title">{t("kontaktTitle")}</PageTitle>

      <div
        className="mx-auto mt-10 w-full max-w-3xl space-y-6 text-[17px] leading-[1.6] sm:text-[18px]"
        style={{ color: "#1A1A1A" }}
      >
        <p>{t("kontakt_p1")}</p>
        <p
          className="border-l-2 pl-5 italic"
          style={{ borderColor: "#2A2624" }}
        >
          {t("kontakt_quote")}
        </p>
      </div>
    </PageLayout>
  );
}
